import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { themeClasses } from "sj-ui-toolkit/src/atlas/utils";

interface UserSelectionConfirmDialogProps {
  visible: boolean;
  onHide: () => void;
  onContinue: () => void;
  onAddUsersAndContinue: () => void;
  selectedUsersCount?: number;
}

const UserSelectionConfirmDialog = ({
  visible,
  onHide,
  onContinue,
  onAddUsersAndContinue,
  selectedUsersCount = 0,
}: UserSelectionConfirmDialogProps) => {
  const footer = (
    <div className="flex justify-end gap-2">
      <Button
        label="Continue"
        severity="secondary"
        onClick={onContinue}
        data-testid="continue-button"
      />
      <Button
        label="Add Users and Continue"
        onClick={onAddUsersAndContinue}
        data-testid="add-users-continue-button"
      />
    </div>
  );

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header="Confirm Navigation"
      footer={footer}
      modal
      maskStyle={{ backdropFilter: "blur(5px)" }}
      className="w-full max-w-xl"
      data-testid="user-selection-confirm-dialog"
    >
      <div className="flex flex-col gap-4">
        <div className="flex items-center gap-3">
          <i className={`pi pi-exclamation-triangle ${themeClasses.iconWarning} text-2xl`} />
          <div>
            <p className="mb-2">
              You have selected {selectedUsersCount} user{selectedUsersCount !== 1 ? "s" : ""} but
              haven&apos;t added them.
            </p>
            <p className={`body-sm ${themeClasses.textGray600}`}>What would you like to do?</p>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default UserSelectionConfirmDialog;
